import React, { Suspense } from 'react';
import type { MapModeContext, MapModeStrategy, PopupData } from '../mapModes/MapModeStrategy';
import type { PopupAdditionalData } from '../hooks/useMapPopup';

interface StrategyPopupProps {
	strategy: MapModeStrategy;
	infraInfo: PopupData;
	mapContext: MapModeContext;
	popupAdditionalData: PopupAdditionalData | null;
	onClose: () => void;
	onMouseDown: (e: React.MouseEvent) => void;
	isDragging: boolean;
}

const StrategyPopup: React.FC<StrategyPopupProps> = ({
	strategy,
	infraInfo,
	mapContext,
	popupAdditionalData,
	onClose,
	onMouseDown,
	isDragging,
}) => {
	const popupProps = strategy.getPopupProps
		? strategy.getPopupProps(infraInfo, mapContext, popupAdditionalData)
		: { data: infraInfo };

	const PopupComp = strategy.PopupComponent;

	return (
		<Suspense fallback={<div className="p-4">Loading...</div>}>
			<PopupComp
				{...popupProps}
				onClose={onClose}
				onMouseDown={onMouseDown}
				isDragging={isDragging}
			/>
		</Suspense>
	);
};

export default StrategyPopup;
